import dayjs from "dayjs";

import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { getAge } from "@/utils/dateUtil";
import { DetailedCitizenAttendancesIndicatorC6Data } from "@/services/esus/indicator/esf/c6/getDetailedCitizensAttendancesIndicatorC6";

import { TimeLine, TimeLineContent } from "@/components/TimeLine";
import { IndicatorEsfC6CitizenAttendancesHistoryItem } from "./IndicatorEsfC6CitizenAttendancesHistoryItem";
import { IndicatorEsfC6CitizenAttendancesHistoryInfo } from "./IndicatorEsfC6CitizenAttendancesHistoryInfo";

type IndicatorEsfC6CitizenAttendancesHistoryProps = {
	citizenWithAttendances: DetailedCitizenAttendancesIndicatorC6Data;
};

export function IndicatorEsfC6CitizenAttendancesHistory({
	citizenWithAttendances,
}: Readonly<IndicatorEsfC6CitizenAttendancesHistoryProps>) {
	const indicatorEsfC6CitizenHistoryInfo = {
		fullName: citizenWithAttendances.fullName ? citizenWithAttendances.fullName : "N/A",
		birthdate: citizenWithAttendances.birthdate
			? dayjs(citizenWithAttendances.birthdate).format("DD/MM/YYYY")
			: "N/A",
		age: citizenWithAttendances.birthdate ? getAge(citizenWithAttendances.birthdate) : "N/A",
		document: citizenWithAttendances.cpf
			? formatIdentifier(citizenWithAttendances.cpf)
			: citizenWithAttendances.cns ?? "",
		motherName: citizenWithAttendances.motherName ?? "",
		phone: citizenWithAttendances.phone ? phoneFormat(citizenWithAttendances.phone) : "",
		address:
			addressConcat(
				citizenWithAttendances.street,
				citizenWithAttendances.houseNumber,
				citizenWithAttendances.neighborhood
			) ?? "",
	};

	return (
		<>
			<IndicatorEsfC6CitizenAttendancesHistoryInfo {...indicatorEsfC6CitizenHistoryInfo} />
			<TimeLine
				timeLineTitle="Consultas"
				timeLineContents={(citizenWithAttendances.attendances ?? []).map<TimeLineContent>(
					(attendance) => {
						return {
							content: (
								<IndicatorEsfC6CitizenAttendancesHistoryItem
									attendance={attendance}
								/>
							),
							eventDate: attendance.date
								? dayjs(attendance.date).format("DD/MM/YYYY")
								: "N/A",
						};
					}
				)}
			/>
			<TimeLine
				timeLineTitle="Registros de Peso e Altura"
				timeLineContents={(
					citizenWithAttendances.weightAndHeightMetricsRegisters ?? []
				).map<TimeLineContent>((metricsAttendance) => {
					return {
						content: (
							<IndicatorEsfC6CitizenAttendancesHistoryItem
								attendance={metricsAttendance}
							/>
						),
						eventDate: metricsAttendance.date
							? dayjs(metricsAttendance.date).format("DD/MM/YYYY")
							: "N/A",
					};
				})}
			/>
		</>
	);
}
